<template>
  <component
    :is="labelContainer"
    :id="id"
    :disabled="disabled || disable || undefined"
    class="label"
    :title="label"
    :class="[disabled || disable ? 'disabled' : null]"
    :data-testid="`label-${testId}`"
  >
    <slot :id="id" name="label">
      {{ label }}
    </slot>
  </component>
  <slot :id="id" name="text">
    <component
      :is="textContainer"
      v-if="text || $slots.default"
      :class="['text', boldText && 'bold', contentClass, disabled || disable ? 'disabled' : null]"
      :data-testid="`value-${testId}`"
    >
      <slot :id="id">
        <span v-if="text" class="labeled-text">{{ text }}</span>
      </slot>
    </component>
  </slot>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import { randomID } from "../../../utils/helpers";
import { makeHtmlIdSafe } from "../../../utils/strings";

const props = defineProps({
  id: String,
  label: {
    type: String,
    default: "",
  },
  labelClass: String,
  text: {
    type: null,
    default: "",
  },
  labelContainer: {
    type: String,
    default: "dt",
  },
  textContainer: {
    type: String,
    default: "dd",
  },
  boldText: {
    type: Boolean,
    default: false,
  },
  contentClass: [String, Array, Object],
  disable: Boolean,
  disabled: Boolean,
});

const id = computed(() => props.id ?? randomID("labeled-text-"));
const testId = computed(() => makeHtmlIdSafe(props.label));
</script>
<style lang="scss" scoped>
/* Stack each dt/dd pair together */
dt {
  break-after: avoid;
}
dd {
  break-before: avoid;
  > :first-child {
    padding-bottom: var(--gap-3);
  }
}

.labeled-text {
  margin: 0;
  padding-bottom: var(--gap-3);
}

.label {
  display: flex;
  font-style: normal;
  font-size: 14px;
  font-weight: bold;
  word-wrap: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  text-wrap: wrap;
}

.text {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  /* identical to box height */
  color: var(--text-color);
  word-break: break-word;
}
</style>
